import { Role, User } from "../../auth/types/interfaces";
import { successResponse, forbiddenResponse } from "../constants";
export const loader = async (user: User) => {
  /**
   * Loader function for Workers Compensation pages
   *
   * @returns {Promise<Response>} A Promise that resolves with a Response object.
   *   Returns OK if has role
   *   Returns 404 not found if doesn't have role
   */
  if (
    user.roles.includes(Role.WC_CLAIM_USER) ||
    user.roles.includes(Role.WC_CLAIM_PRODUCT_GROUP) ||
    user.roles.includes(Role.WC_CLAIM_USER_LIMITED) ||
    user.roles.includes(Role.WC_CLAIM_CANADA_USER)
  ) {
    return successResponse();
  } else {
    throw forbiddenResponse();
  }
};
